<mat-card class="slidecontent">
  <div class="headcontent">
  
      <div class="pophead">
          <h3>Add Task </h3>
            <button mat-icon-button class="close" ><mat-icon (click)="closeCreate(createClose)">close</mat-icon></button>
        </div>
    </div>

        <div class="dialog_content">
            <form  class="fix-mat-form-field" >
              <mat-form-field class="example-full-width">
                  <mat-label>Task Name</mat-label>
                  <input matInput placeholder="Task Name" value="">
                </mat-form-field>

                <div class="subtaskHolder" *ngIf="SubTask" >
                  <div class="rep">
                    <div class="start">
                      <mat-icon>subdirectory_arrow_right</mat-icon>
                    </div>
                   
                    <mat-form-field class="example-full-width">
                      <mat-label>Subtask</mat-label>
                      <input matInput placeholder="Add Subtask Name" value="">
                    </mat-form-field>
                    <button mat-icon-button class="remove" ><mat-icon >remove_circle_outline</mat-icon></button>
                  </div>
                </div>

                <button class="subtask" (click)="showSubTask()" mat-button color="primary" > <mat-icon>add</mat-icon> Subtask </button>

              <mat-form-field>
                  <mat-label>Task Type</mat-label>
                  <mat-select value="" >
                    <mat-option value="" >To Do</mat-option>
                    <mat-option value="">Document</mat-option>
                    <mat-option value="">Appointment</mat-option>
                    <mat-option value="" > Phone Call</mat-option>
                    <mat-option value="">Email</mat-option>
                    <mat-option value="">Meeting</mat-option>
                    <mat-option value="">Other</mat-option>
                  </mat-select>
                </mat-form-field>  
                
                <div class="two">
                  <mat-form-field class="example-full-width">
                      <mat-label>Due Date</mat-label>
                      <input matInput placeholder="Due Date" value="">
                      <mat-icon matSuffix>date_range</mat-icon>
                    </mat-form-field>
                    <mat-form-field class="example-full-width">
                      <mat-label>Time</mat-label>
                      <input matInput placeholder="Time" value="">
                      <mat-icon matSuffix>query_builder</mat-icon>
                    </mat-form-field>
                </div>


                <div class="two">
                  <mat-form-field>
                    <mat-label>Assign To </mat-label>
                    <mat-select value="" multiple >
                      <mat-option value="" >Matt</mat-option>
                      <mat-option value="">Johan</mat-option>
                      <mat-option value="">Robert</mat-option>
                    </mat-select>
                  </mat-form-field>  
                  <mat-form-field>
                    <mat-label>Priority</mat-label>
                    <mat-select value="" >
                      <mat-option value="" >ASAP</mat-option>
                      <mat-option value="">Soon</mat-option>
                      <mat-option value="">Postpone</mat-option>
                      <mat-option value="">Other</mat-option>
                    </mat-select>
                  </mat-form-field>  

                </div>


                <div class="two">
                  <mat-form-field>
                    <mat-label>Type</mat-label>
                    <mat-select value="" >
                      <mat-option value="" >ECM</mat-option>
                      <mat-option value="">Signashare</mat-option>
                    </mat-select>
                  </mat-form-field>  
                  <mat-form-field>
                    <mat-label>Owner</mat-label>
                    <mat-select value="" >
                      <mat-option value="" >Matt</mat-option>
                      <mat-option value="">James</mat-option>
                    </mat-select>
                  </mat-form-field>  

                </div>

                <mat-form-field>
                  <mat-label>Description</mat-label>
                  <textarea matInput
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="3"
                            cdkAutosizeMaxRows="5"></textarea>
                </mat-form-field>

                <div class="two">
                  <mat-form-field class="example-full-width">
                      <mat-label>Last Touch</mat-label>
                      <input matInput placeholder="Last Touch" value="">
                      
                    </mat-form-field>
                    <mat-form-field class="example-full-width">
                      <mat-label>Next Touch</mat-label>
                      <input matInput placeholder="Next Touch" value="">
                      
                    </mat-form-field>
                </div>

                      
                <div class="reminder">
                  <div class="remind">
                    Reminder
                    <mat-slide-toggle color="primary" ></mat-slide-toggle>
                  </div>  

                  <mat-radio-group color="primary" aria-label="Select an option">
                    <mat-radio-button value="1">Before 30 minutes</mat-radio-button>
                    <mat-radio-button value="2">Before 1 hour</mat-radio-button>
                  </mat-radio-group>
                  <!-- <a href="#" class="custom" >Custom</a> -->
                </div>


            </form>
    
        </div>
  
  
  <div class="actionBtn">
  
  <button mat-flat-button class="cancel" (click)="closeCreate(createClose)"  >Cancel</button>
  <button mat-flat-button class="calltoaction" type="submit"  color="primary">Add</button>
  </div>
  
</mat-card>

<div class="overlay" (click)="closeCreate(createClose)" ></div>